import React from "react";
import { DefaultFooter } from "@ant-design/pro-layout";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const icp = "京ICP备2025153422号";

  return (
    <div
      style={{
        marginTop: 4,
        padding: "4px 0",
        textAlign: "center",
        fontSize: 12
      }}
    >
      <span>
        {currentYear} 萝卜屋系统{" "}
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
        >
          {icp}
        </a>
      </span>
    </div>
  );
};

export default Footer;
